import { ScrollArea, Stack, createStyles } from '@mantine/core';
import type { AiAgentsHistoryBodyProps } from '../types';

const useStyles = createStyles((theme) => ({
	groupedChatsWrapper: {
		height: '100%',
		gap: theme.spacing.md,
		padding: `0 ${theme.spacing.xs} 0 ${theme.spacing.md}`,
	},
	scrollAreaViewport: {
		paddingBottom: theme.spacing['xl'],

		'>div': {
			display: 'block !important',
		},
	},
}));

export function AiAgentsHistoryBody({ children }: AiAgentsHistoryBodyProps) {
	const { classes } = useStyles();

	return (
		<ScrollArea
			classNames={{
				viewport: classes.scrollAreaViewport,
			}}
			type="scroll"
		>
			<Stack className={classes.groupedChatsWrapper}>{children}</Stack>
		</ScrollArea>
	);
}
